import { useEffect, useState } from 'react';
import type { IUpcomingFeature } from '@skystone/shared';
import { formatPhaseLabel } from '@skystone/shared';
import { upcomingFeatureApi } from '@/services/upcoming-feature-api';
import { Badge, Spinner } from '@/components/ui';

export function WhatsComingFeed() {
  const [items, setItems] = useState<IUpcomingFeature[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    upcomingFeatureApi
      .getAll({ limit: 8 })
      .then((data) => {
        if (!cancelled) setItems(data);
      })
      .catch(() => {
        if (!cancelled) setError('Failed to load upcoming features.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="space-y-4">
      <div>
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          What&apos;s coming
        </p>
        <h2 className="text-xl font-bold tracking-tight text-foreground">
          Features in the pipeline
        </h2>
      </div>

      {error && <p className="text-sm text-muted-foreground">{error}</p>}

      {!error && items === null && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Spinner /> Loading…
        </div>
      )}

      {!error && items !== null && items.length === 0 && (
        <p className="text-sm text-muted-foreground">Nothing in the pipeline right now.</p>
      )}

      {!error && items !== null && items.length > 0 && (
        <ul className="space-y-3">
          {items.map((item) => (
            <li key={item.id} className="flex gap-3">
              <Badge variant="secondary" className="mt-0.5 shrink-0 uppercase tracking-wider">
                {formatPhaseLabel(item.phase)}
              </Badge>
              <div className="min-w-0 space-y-1">
                <h3 className="text-sm font-semibold text-foreground">{item.title}</h3>
                <p className="text-sm text-muted-foreground">{item.description}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
